export const environment = {
  production: true,
  apiUrl: 'https://dev-backend.wedavinci.com/api',
  backend: 'https://dev-backend.wedavinci.com',
  topicVizApi: 'https://dev-backend.wedavinci.com/api/topicviz',
  entityRecognitionUrl: 'https://staging-entrecog.wedavinci.com',
  gpt3Api: 'https://dev-backend.wedavinci.com/api/smart-interaction',
  assetsUrl: 'https://dev-assets.wedavinci.com',
  featureFlags: {
    reportGeneration: false,
    projectCreation: {
      topicInput: true,
      textInput: true,
      sourcesInput: true,
      customStyleInput: true,
      fastProjectCreation: true,
      startManually: true,
      storyboard: true,
    },
    projectEdit: {
      feedback: true,
      customInstruction: true,
      polling: false,
    },
    topic: {
      moveProjects: false,
    },
  },
  __unstable__featureFlags: {
    'audio-project': {
      released: false,
      whitelist: [
        'serhii.prodan@wedavinci.com',
        'hagossssss.sd+1@gmail.com',
        'wenbin.le@wedavinci.com',
        'veronika.gamper@wedavinci.com',
        'vgamper@gmail.com',
      ],
    },
    'video-project': {
      released: false,
      whitelist: [
        'serhii.prodan@wedavinci.com',
        'hagossssss.sd+1@gmail.com',
        'wenbin.le@wedavinci.com',
        'veronika.gamper@wedavinci.com',
        'vgamper@gmail.com',
      ],
    },
  },
};
